module.exports = __webpack_public_path__ + "img/r.267a838a.png";